// export const API_URL = `http://localhost:800/`
export const API_URL = `https://be.spinterindo.com/`
export const version = `24.01.06`